import { render, staticRenderFns } from "./channelAccountEdit.vue?vue&type=template&id=513943e0&scoped=true&"
import script from "./channelAccountEdit.vue?vue&type=script&lang=js&"
export * from "./channelAccountEdit.vue?vue&type=script&lang=js&"
import style0 from "./channelAccountEdit.vue?vue&type=style&index=0&id=513943e0&lang=less&scoped=true&"
import style1 from "./channelAccountEdit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513943e0",
  null
  
)

export default component.exports